import { render, staticRenderFns } from "./IconBasket.vue?vue&type=template&id=ee01f6da&scoped=true&"
import script from "./IconBasket.vue?vue&type=script&lang=js&"
export * from "./IconBasket.vue?vue&type=script&lang=js&"
import style0 from "./IconBasket.vue?vue&type=style&index=0&id=ee01f6da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee01f6da",
  null
  
)

export default component.exports